import { render, staticRenderFns } from "./AsCoachInspectWorkspace.vue?vue&type=template&id=71e61436&scoped=true"
import script from "./AsCoachInspectWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./AsCoachInspectWorkspace.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsCoachInspectWorkspace.vue?vue&type=style&index=0&id=71e61436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e61436",
  null
  
)

export default component.exports